































































import { Component, Prop, Vue } from 'vue-property-decorator';

import { PasswordInput } from '@/common/auth';
import { ErrorMessage } from '@/common/errors';
import { UserStore } from '@/store/user';

@Component({
  components: {
    ErrorMessage,
    PasswordInput,
  },
})
export default class StandardLayoutChangePassword extends Vue {
  @Prop() username!: string;

  credentials = { oldPassword: '', newPassword: '', confirmPassword: '' };
  error = null;
  isSubmitting = false;
  @UserStore.Bind.Action changePassword!: UserStore.Action<'changePassword'>;

  get isSubmitDisabled() {
    return this.isSubmitting ||
           !(this.credentials.oldPassword.length) ||
           !(this.credentials.newPassword.length) ||
           (this.credentials.newPassword !== this.credentials.confirmPassword);
  }

  async submit() {
    this.error = null;
    this.isSubmitting = true;
    const credentials = { ...this.credentials, username: this.username };

    try {
      await this.changePassword(credentials);
      this.$emit('input');
    }
    catch (error) {
      this.error = error;
    }
    finally {
      this.isSubmitting = false;
    }
  }
}
